import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md q-card",
  style: {"width":"700px","max-width":"80vw"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Edit Member Supervisor", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_members_edit_member_supervisor_form = _resolveComponent("members-edit-member-supervisor-form")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_members_edit_member_supervisor_form, {
          onCloseDialog: _ctx.onCancelClick,
          memberId: _ctx.memberId,
          organizationId: _ctx.organizationId,
          supervisorId: _ctx.supervisorId,
          updateCallback: _ctx.updateCallback
        }, null, 8, ["onCloseDialog", "memberId", "organizationId", "supervisorId", "updateCallback"])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}